/** @file The signals emitted by our client. */
import { signal } from '@codegrade/utils';
/** Emitted after a user has been logged out. */
export const AFTER_USER_LOGGED_OUT = new signal.Signal('AFTER_USER_LOGGED_OUT');
/** Emitted when a user has logged in. */
export const USER_LOGGED_IN = new signal.Signal('USER_LOGGED_OUT');
